var OK = window.OK || (window.OK = {});

OK.ntf = {
    close: OK.fn.empty,
    lock: OK.fn.empty
};
